import React, { useState, useCallback, useMemo } from "react";
import {
  Modal,
  Button,
  TextField,
  Select,
  Typography,
  RadioButton,
} from "@ann/web-components";
import {
  ModalContent,
  FormField,
  RadioGroup,
  RadioOption,
  RadioOptionContent,
  RadioOptionLabel,
  DocumentInputWrapper,
  DescriptionText,
  HumanSelectWrapper,
  RadioOptionAgentic,
} from "./LinkSourceDocumentModal.styled";
import { useMediaQueries } from "../../../../../../../utils/mediaQueries";

const LinkSourceDocumentModal = ({ isOpen, onClose, factData, onLink }) => {
  const [sourceType, setSourceType] = useState("document");
  const [documentName, setDocumentName] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { isMobile, isIpadAirPortrait, isIpadProPortrait } = useMediaQueries();

  const modalWidth = useMemo(() => {
    if (isMobile || isIpadAirPortrait || isIpadProPortrait) {
      return "95%";
    }
    return "500px";
  }, [isMobile, isIpadAirPortrait, isIpadProPortrait]);

  const handleSourceTypeChange = useCallback((type) => {
    setSourceType(type);
  }, []);

  const handleBrowseClick = useCallback(() => {
    // TODO: Implement file browser logic
    console.log("Browse clicked");
  }, []);

  const handleLink = useCallback(async () => {
    setIsLoading(true);
    try {
      const linkData = {
        sourceType,
        documentName: sourceType === "document" ? documentName : null,
        selectedPerson: sourceType === "human" ? selectedPerson : null,
      };

      // TODO: Implement linkSourceDocument API call
      // const response = await linkSourceDocument(factData.id, linkData);

      if (onLink) {
        onLink(linkData);
      }

      onClose();
    } catch (error) {
      console.error("Error linking source:", error);
      // TODO: Show error message to user
    } finally {
      setIsLoading(false);
    }
  }, [sourceType, documentName, selectedPerson, onLink, onClose, factData]);

  const handleCancel = useCallback(() => {
    setSourceType("document");
    setDocumentName("");
    setSelectedPerson("");
    onClose();
  }, [onClose]);

  // TODO: Replace with real API call to get people list
  const peopleOptions = [
    { value: "person1", label: "John Doe" },
    { value: "person2", label: "Jane Smith" },
    { value: "person3", label: "Bob Johnson" },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      size="medium"
      width={modalWidth}
    >
      <Modal.Header>
        <Modal.Header.Title>Link to Source Document</Modal.Header.Title>
      </Modal.Header>
      <Modal.Body>
        <ModalContent>
          <Typography
            category="body"
            size="medium"
            weight="regular"
            color="body"
          >
            Select the source type for this knowledge base unit.
          </Typography>

          <FormField>
            <Typography category="label" size="small" weight="bold">
              Source Type
            </Typography>
            <RadioGroup>
              {/* Document / AIMS Drive Document Option */}
              <RadioOption>
                <RadioOptionContent
                  onClick={() => handleSourceTypeChange("document")}
                >
                  <RadioButton
                    onChange={() => handleSourceTypeChange("document")}
                    selected={sourceType === "document"}
                    size="medium"
                  />
                  <RadioOptionLabel>
                  <Typography
                      category="body"
                      size="medium"
                      weight="regular"
                      color="title"
                    >
                      Document / AIMS Drive Document
                    </Typography>
                  </RadioOptionLabel>
                </RadioOptionContent>
                {sourceType === "document" && (
                  <DocumentInputWrapper>
                    <TextField
                      value={documentName}
                      onChange={setDocumentName}
                      placeholder="Market_Analysis_Q4_2025.pdf"
                      size="small"
                    />
                    <Button
                      label="Browse"
                      size="small"
                      type="secondary"
                      iconLeft="description"
                      onClick={handleBrowseClick}
                    />
                  </DocumentInputWrapper>
                )}
              </RadioOption>

              {/* Human Option */}
              <RadioOption>
                <RadioOptionContent
                  onClick={() => handleSourceTypeChange("human")}
                >
                  <RadioButton
                    onChange={() => handleSourceTypeChange("human")}
                    selected={sourceType === "human"}
                    size="medium"
                  />
                  <RadioOptionLabel>
                  <Typography
                      category="body"
                      size="medium"
                      weight="regular"
                      color="title"
                    >
                      Human
                    </Typography>
                  </RadioOptionLabel>
                </RadioOptionContent>
                {sourceType === "human" && (
                  <HumanSelectWrapper>
                    <Select
                      label="Select person"
                      size="small"
                      value={selectedPerson}
                      onChange={setSelectedPerson}
                      placeholder="Select person"
                    >
                      <Select.Menu>
                        {peopleOptions.map((person) => (
                          <Select.Item
                            key={person.value}
                            label={person.label}
                            value={person.value}
                          >
                            {person.label}
                          </Select.Item>
                        ))}
                      </Select.Menu>
                    </Select>
                  </HumanSelectWrapper>
                )}
              </RadioOption>

              {/* Agentic Train Me Option */}
              <RadioOptionAgentic>
                <RadioOptionContent
                  onClick={() => handleSourceTypeChange("agentic")}
                >
                  <RadioButton
                    onChange={() => handleSourceTypeChange("agentic")}
                    selected={sourceType === "agentic"}
                    size="medium"
                  />
                  <RadioOptionLabel>
                    <Typography
                      category="body"
                      size="medium"
                      weight="regular"
                      color="title"
                    >
                      Agentic Train Me
                    </Typography>
                  </RadioOptionLabel>
                </RadioOptionContent>
                <DescriptionText>
                  <Typography
                    category="body"
                    size="medium"
                    weight="regular"
                    color="body"
                  >
                    This fact came from the AI Agent from the department
                  </Typography>
                </DescriptionText>
              </RadioOptionAgentic>
            </RadioGroup>
          </FormField>
        </ModalContent>
      </Modal.Body>
      <Modal.Actions align="end">
        <Button
          label="Cancel"
          size="medium"
          type="secondary"
          onClick={handleCancel}
          disabled={isLoading}
        />
        <Button
          label="Link Source"
          size="medium"
          type="primary"
          iconLeft="link"
          onClick={handleLink}
          disabled={isLoading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default LinkSourceDocumentModal;
